import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { DisclaimerComponent } from "@shared/components/commons/disclaimer/disclaimer.component";
import { IndividualsApiService } from "@shared/services/individuals-api.service";
import { debounceTime, of, Subject, switchMap, tap } from "rxjs";
import { MaskedInputComponent } from '../../masked-input.component';

@Component({
  selector: 'app-din-masked-input',
  standalone: true,
  imports: [
    MaskedInputComponent,
    ReactiveFormsModule,
    DisclaimerComponent
  ],
  templateUrl: './din-masked-input.component.html'
})
export class DinMaskedInputComponent extends MaskedInputComponent implements OnInit {
  individualApiService = inject(IndividualsApiService);
  destroyRef = inject(DestroyRef);

  @Input() override mask = '___ _____ _____ __';
  @Input() override placeholder = '___ _____ _____ __';
  @Input() override label = 'Director ID';

  @Input() shouldCheckDin = false;

  @Input('fullNameForCheck') set fullNameForCheckSetter(value: string | null) {
    this.fullNameForCheck = value;
    this.dinCheckTrigger.next(null);
  }

  readonly incorrectDinMessage = 'Director ID does not match the existing records. Please verify the number before proceeding.';

  showIncorrectDinMessage = false;
  fullNameForCheck: string | null = null;
  dinCheckTrigger = new Subject<null>();

  ngOnInit(): void {
    this.ngControl.control?.setValidators([
      Validators.minLength(15),
      Validators.maxLength(15)
    ]);

    this.dinCheckTrigger
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => this.showIncorrectDinMessage = false),
        debounceTime(500),
        switchMap(() => {
          const din = (this.control?.value ?? null) as string | null;

          if (!this.shouldCheckDin || this.control?.invalid || !this.fullNameForCheck || !din)
            return of(true);

          return this.individualApiService.checkIndividualByDin(din, this.fullNameForCheck);
        })
      )
      .subscribe({
        next: (isDinValid: boolean) => this.showIncorrectDinMessage = !isDinValid,
        error: (error) => console.warn('[DinMaskedInputComponent] error: ', error)
      });

    this.dinCheckTrigger.next(null);
  }

  override writeValue(value: any) {
    super.writeValue(value);
    this.dinCheckTrigger.next(null);
  }
}
